<template>
  <div class="content">
    <div class="container containerStatistics">
      <div class="row">
        <h1>أهلًا بك في لوحة تحكم "الفرسان"</h1>
        <h3>الإحصائيات الحالية:</h3>
        <!-- Product Count Card -->
        <div class="col-md-6">
          <div class="card card-stats">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-success">
                    <i class="fas fa-shopping-cart text-primary"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">عدد المنتجات</p>
                    <h4 class="card-title">{{ productCount }}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Category Count Card -->
        <div class="col-md-6">
          <div class="card card-stats">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-danger">
                    <i class="fas fa-sitemap text-success"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">عدد الأقسام</p>
                    <h4 class="card-title">{{ categoryCount }}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- User Count Card -->
        <div class="col-md-6" v-if="decodedToken == 'ادمن'">
          <div class="card card-stats">
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="icon-info">
                    <i class="fas fa-users text-info"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p class="card-category">عدد المستخدمين</p>
                    <h4 class="card-title">{{ userCount }}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "../../Axios";
import LTable from "src/Dashboard/SharedComponents/Table.vue";
import jwt_decode from "jwt-decode";

export default {
  components: {
    LTable,
  },
  data() {
    return {
      productCount: "Loading...",
      categoryCount: "Loading...",
      userCount: "Loading...",
      token: null,
      decodedToken: null,
    };
  },
  created() {
    this.fetchStatistics();
    this.token = localStorage.getItem("adminToken");
    this.decodedToken = this.token ? jwt_decode(this.token).role : null;
  },
  methods: {
    fetchStatistics() {
      // Users
      Axios.get("/users")
        .then((response) => {
          this.userCount = response.data.totalUsers;
        })
        .catch((error) => {
          // console.error(error);
        });

      // Products
      Axios.get("/products")
        .then((response) => {
          this.productCount = response.data.totalProducts;
        })
        .catch((error) => {
          // console.error(error);
        });

      // Categories
      Axios.get("/category")
        .then((response) => {
          this.categoryCount = response.data.totalCategories;
        })
        .catch((error) => {
          // console.error(error);
        });
    },
  },
};
</script>

<style scoped>
.content {
  padding: 20px;
}

.containerStatistics {
  padding: 4%;
  background-color: #ffffffd4;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 25px;
  margin-top: 30px;
}

.containerStatistics > .row > h1 {
  color: #616060;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  font-weight: 400;
  margin-bottom: 40px;
  text-align: center;
}

.containerStatistics > .row > h3 {
  margin-bottom: 30px;
  color: #616060;
}

.card-stats {
  border: 1px solid #e6e6e6;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  padding: 15px;
}

.card-title {
  font-size: 24px;
  margin-top: 10px;
}

.card-category {
  font-size: 14px;
}

/* Icon Styling */
.icon-success i {
  color: #28a745;
  font-size: 40px;
}

.icon-danger i {
  color: #dc3545;
  font-size: 40px;
}

.icon-info i {
  color: #17a2b8;
  font-size: 40px;
}

/* Responsive Styling */
@media (max-width: 768px) {
  .col-md-4 {
    flex: 0 0 100%;
  }
}
</style>
